"use client";

import {Stack, Text} from "@chakra-ui/react";
import Title from "@/components/title";
import PageLayout from "@/layouts/pageLayout";
import {CONTACT_US_CONSTANTS} from "./contactUs.constants";
import IntroLayout from "@/components/introLayout";
import {TEXT_VARIANTS} from "@/theme/components/text";

const ContactUs = () => {
  const heading = [CONTACT_US_CONSTANTS.CONTACT_US];
  return (
    <PageLayout marginTop={12} spacing={8} showContactForm>
      <IntroLayout
        image={"/contactForm/contactIntro.svg"}
        content={CONTACT_US_CONSTANTS.CONTACT_US_DESC}
        heading={heading}
      />
      <Title title={CONTACT_US_CONSTANTS.CONTACT_US_FORM_TITLE} />
      <Stack p={"30px"} bg={"primary.100"} w={"full"}>
        <Text textAlign={"center"} variant={TEXT_VARIANTS.BODY2}>
          {CONTACT_US_CONSTANTS.CONTACT_US_FORM_TITLE_TEXT}
        </Text>
      </Stack>
    </PageLayout>
  );
};

export default ContactUs;
